import { render, staticRenderFns } from "./AdminTitle.vue?vue&type=template&id=ab01126c&scoped=true&"
import script from "./AdminTitle.vue?vue&type=script&lang=js&"
export * from "./AdminTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab01126c",
  null
  
)

export default component.exports